<template>
  <div>
    <div class="row ">
      <div class="col-12">
        <label class="form-label">{{ $t("What's included") }}</label>
      </div>
    </div>
    <div v-if="this.included_services" class="row mt-2" v-for="(service,index) in this.included_services">
      <div class="col-10">
        <textarea class="form-control"
                  placeholder="Product Description"
                  rows="2" v-model="service.description" name="included[]" maxlength="70"
                  @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
                  @input='charCount(event, index)'
                  ></textarea>
      <div class="note text-medium-gray"><strong>{{ maxChars[index] }}</strong> {{ $t('chars remaining') }}</div>
      </div>
      <div class="col-2 d-flex justify-content-center">
        <a class="btn btn-square btn-danger rounded-circle" @click="removeService(index)">
            <span class="svg-icon">
                <i class="bi bi-archive-fill"></i>
            </span>
        </a>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-2">
        <button type="button" class="btn btn-custom-primary" @click="addService">{{ $t('New') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

const maxWhatsIncluded = 70;

export default {
  props: {
    old: Array
  },
  components: {}
  ,
  data: function () {
    return {
      maxWhatsAdded: maxWhatsIncluded,
      included_services: [],
      maxChars: [],
    }
  },
  methods: {
    addService() {
      this.included_services.push({
        id: this.included_services.length + 1,
        description: ''
      });
      this.maxChars[this.maxChars.length] = this.maxWhatsAdded;
    },
      charCount: function(e, index){
          var evt = e || window.event;
          this.maxChars[index] = this.maxWhatsAdded - evt.target.value.length;
          this.maxChars[index] = this.maxChars[index] < 0 ? 0 : this.maxChars[index];
      },
    removeService(index) {
      this.included_services.splice(index, 1);
      this.maxChars.splice(index, 1);
    }
  },
  mounted() {

    if (this.old.length !== 0) {
      this.included_services = [];//empty array

      let index = 0;
      this.old.forEach(
          el => {
              this.included_services.push({description: el});
              this.maxChars[index] = this.maxWhatsAdded - this.included_services[index].description.length;
              this.maxChars[index] = this.maxChars[index] < 0 ? 0 : this.maxChars[index];
              index++;
          }
      );

    } else {
        this.maxChars = [];
        this.maxChars[0] = this.maxWhatsAdded;
    }
  }
}
</script>

